import React, { RefObject } from 'react';
import { SlugAlternative } from '../../../../types/navigation.types';


import DesktopNavigationGrid from '@components/navigation/components/desktop/DesktopNavigationGrid.component';



interface IDesktopNavigation {
  refWrapper: RefObject<HTMLDivElement>;
  refProductNavigation: RefObject<HTMLDivElement>;
  multilingualSlugsForStaticPages: SlugAlternative[];
  isProductSite?: boolean;
  isKnowledgeBase?: boolean;
  multilingualSlugsForCmsArticle:any;
  pageType: any;
}

const DesktopNavigation = (props: IDesktopNavigation) => {
  const {
    refWrapper,
    refProductNavigation,
    multilingualSlugsForStaticPages,
    isKnowledgeBase,
    multilingualSlugsForCmsArticle,
    pageType
  } = props;


  return (
    <>
      <DesktopNavigationGrid
        refWrapper={refWrapper}
        refProductNavigation={refProductNavigation}
        isKnowledgeBase={isKnowledgeBase}
        multilingualSlugsForStaticPages={multilingualSlugsForStaticPages}
        multilingualSlugsForCmsArticle={multilingualSlugsForCmsArticle}
        pageType={pageType}
      />
    </>
  );
};

export default DesktopNavigation;
